<!-- Container da Modal com conteúdo e rodapé fixo -->
<div class="-m-6 -mb-6 flex flex-col flex-grow overflow-hidden">
    <!-- Cabeçalho -->
    <div
        class="flex items-center justify-between h-16 px-6 bg-orange-500 text-white">
        <div class="text-lg font-medium">
            Filtrar Estoque
        </div>
        <button mat-icon-button (click)="onCancel()">
            <mat-icon
                class="text-white"
                svgIcon="heroicons_outline:x"></mat-icon>
        </button>
    </div>

    <!-- Conteúdo com rolagem -->
    <div class="flex-grow overflow-auto px-4 pt-4 pb-6">  
        <mat-dialog-content class="filters-dialog-content">

          <!-- Filtro de Regional -->
          <!-- Regional -->
          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Regional</mat-label>
            <mat-select
              [(ngModel)]="filterData.filterRegional"
              [compareWith]="compareById"
              (selectionChange)="updateFilteredFarms()"
            >
              <mat-option [value]="null">Todas</mat-option>
              <mat-option *ngFor="let regional of filterData.regionals" [value]="regional.id">
                {{ regional.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <!-- Filtro de Fazenda -->
          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Fazenda</mat-label>
            <mat-select [(ngModel)]="filterData.filterFarm" [compareWith]="compareById">
              <mat-option [value]="null">Todas</mat-option>
              <mat-option *ngFor="let farm of filteredFarms" [value]="farm.id">
                {{ farm.identity_name }} - {{ farm.farm_name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <!-- Filtro de Produto -->
          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Produto</mat-label>
            <mat-select [(ngModel)]="filterData.filterProduct">
              <mat-option [value]="null">Todos</mat-option>
              <mat-option *ngFor="let product of filterData.products" [value]="product.description">
                {{ product.description }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <!-- Filtro de Lote -->
          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Lote</mat-label>
            <input matInput [(ngModel)]="filterData.filterBatch" placeholder="Filtrar por lote">
          </mat-form-field>
          <!-- Filtro de Validade -->
          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Validade</mat-label>
            <input matInput [matDatepicker]="validityPicker" [(ngModel)]="filterData.filterValidity" placeholder="Selecione a data">
            <mat-datepicker-toggle matSuffix [for]="validityPicker"></mat-datepicker-toggle>
            <mat-datepicker #validityPicker></mat-datepicker>
          </mat-form-field>
          <!-- Filtro de Tipo -->
          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Tipo</mat-label>
            <mat-select [(ngModel)]="filterData.filterMode">
              <mat-option [value]="null">Todos</mat-option>
              <mat-option value="ondemand">OnDemand</mat-option>
              <mat-option value="onfarm">OnFarm</mat-option>
            </mat-select>
          </mat-form-field>
          <!-- Filtro de Criado -->
          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Criado</mat-label>
            <input matInput [matDatepicker]="createdPicker" [(ngModel)]="filterData.filterCreatedAt" placeholder="Selecione a data">
            <mat-datepicker-toggle matSuffix [for]="createdPicker"></mat-datepicker-toggle>
            <mat-datepicker #createdPicker></mat-datepicker>
          </mat-form-field>
          <!-- Filtro de Atualizado -->
          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Atualizado</mat-label>
            <input matInput [matDatepicker]="updatedPicker" [(ngModel)]="filterData.filterUpdatedAt" placeholder="Selecione a data">
            <mat-datepicker-toggle matSuffix [for]="updatedPicker"></mat-datepicker-toggle>
            <mat-datepicker #updatedPicker></mat-datepicker>
          </mat-form-field>
          <!-- Filtro de Data de Estoque -->
          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Data de Estoque</mat-label>
            <input matInput [matDatepicker]="stockDatePicker" [(ngModel)]="filterData.filterStockDate" placeholder="Selecione a data">
            <mat-datepicker-toggle matSuffix [for]="stockDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #stockDatePicker></mat-datepicker>
          </mat-form-field>
      </mat-dialog-content>
    </div>

    <!-- Rodapé fixo -->
    <div class="border-t border-gray-300 pt-5 px-4 flex justify-end gap-3 bg-white shadow-md z-10 pb-4">
      <mat-dialog-actions align="end" class="pb-5 -pt-5">
        <button
          mat-button
          (click)="onCancel()"
          class="rounded-full bg-gray-200 px-6 py-2 hover:bg-gray-300 text-black"
        >
          Cancelar
        </button>
        <button
          mat-button
          color="primary"
          (click)="onApply()"
          class="rounded-full bg-orange-500 px-6 py-2 hover:bg-orange-600 text-white"
        >
          Aplicar
        </button>
      </mat-dialog-actions>
    </div>
</div>
